import React, { useState } from 'react';
import { Submenu } from './submenu';
import { NavLink as RRDNavLink } from 'react-router-dom';
import { MenuArrow, MenuIcon, MenuLabel, MenuItem as MenuItemWrapper, MenuLink } from './menu';
import './menu.sass';

const NavLink = ({ isActive, ...restProps }) => {
  return (
    <RRDNavLink
      {...restProps}
      className={({ isActive: rrdIsActive }) => {
        return rrdIsActive || isActive ? 'menu__link menu__link--is-active' : 'menu__link';
      }}
    />
  );
};

export function MenuItem({ item }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const pathname = window.location.pathname;

  const subroutes = item?.submenu?.nav.map(item => item.route.split('/')[1]);

  const hasRoute = item?.route !== '/' && pathname.includes(item?.route);
  const hasSubroutes = pathname !== '/' && subroutes?.includes(pathname.split('/')[1]);

  const handleShowSubmenu = e => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const showMenuItem = item?.submenu?.nav?.some(item => item?.visible);

  if (!item?.submenu)
    return (
      <MenuItemWrapper>
        <NavLink
          to={item?.route}
          isActive={hasRoute}
        >
          <MenuIcon>{item?.icon}</MenuIcon> {item?.label && <MenuLabel>{item?.label}</MenuLabel>}
        </NavLink>
      </MenuItemWrapper>
    );

  return (
    showMenuItem && (
      <MenuItemWrapper
        hasSubmenu
        isExpanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <MenuLink isActive={hasSubroutes}>
          <span onClick={handleShowSubmenu}>
            <MenuIcon>{item?.icon}</MenuIcon> {item?.submenu?.title && <MenuLabel>{item?.submenu?.title}</MenuLabel>} <MenuArrow isExpanded={isExpanded} />
          </span>
        </MenuLink>

        <Submenu data={item?.submenu} />
      </MenuItemWrapper>
    )
  );
}
